<template>
  <div
    class="container-d flex"
    style="flex-direction: column; min-height: 100vh"
  >
    <HeaderItem />
    <Nav />
    <BackTop />
    <div style="flex: 1" v-loading.fullscreen="!isInit">
      <router-view :key="route.fullPath" class="inherit-h" v-if="isInit" />
    </div>
    <Footer />
    <Copyright :count="uv" />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { countPV } from '@/api/config'

import BackTop from '@/components/back-top/index.vue'

import HeaderItem from './components/header-item/index.vue'
import Nav from './components/nav-item/index.vue'
import Footer from './components/footer/index.vue'
import Copyright from './components/copyright/index.vue'

const route = useRoute()
const store = useStore()
const isInit = ref(false)
const uv = ref(0)

onMounted(() => {
  store.dispatch('init').then(() => {
    isInit.value = true
  })
  countPV().then((res) => {
    uv.value = res * 1
  })
})

window.addEventListener('resize', () => {
  store.commit('setWindowWidth', window.innerWidth)
})
</script>

<style lang="scss" scoped></style>
